module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "new-site"
  }, [_c('el-form', {
    ref: "siteData",
    staticClass: "new-site-form",
    attrs: {
      "model": _vm.siteData,
      "rules": _vm.validators,
      "label-width": "200px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.siteData.name),
      callback: function($$v) {
        _vm.$set(_vm.siteData, "name", $$v)
      },
      expression: "siteData.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Address",
      "prop": "address"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.siteData.address),
      callback: function($$v) {
        _vm.$set(_vm.siteData, "address", $$v)
      },
      expression: "siteData.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Latitude",
      "prop": "lat"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.siteData.lat),
      callback: function($$v) {
        _vm.$set(_vm.siteData, "lat", $$v)
      },
      expression: "siteData.lat"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Longitude",
      "prop": "long"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.siteData.long),
      callback: function($$v) {
        _vm.$set(_vm.siteData, "long", $$v)
      },
      expression: "siteData.long"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Zoom",
      "prop": "zoom"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.siteData.zoom),
      callback: function($$v) {
        _vm.$set(_vm.siteData, "zoom", $$v)
      },
      expression: "siteData.zoom"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Auto Off Time",
      "prop": "off_time"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.siteData.off_time),
      callback: function($$v) {
        _vm.$set(_vm.siteData, "off_time", $$v)
      },
      expression: "siteData.off_time"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Standby",
      "prop": "standby"
    }
  }, [_c('el-input-number', {
    model: {
      value: (_vm.siteData.standby),
      callback: function($$v) {
        _vm.$set(_vm.siteData, "standby", $$v)
      },
      expression: "siteData.standby"
    }
  }), _vm._v(" Minutes\n    ")], 1), _vm._v(" "), _c('div', {
    staticClass: "separator"
  }), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "align": "left"
    },
    attrs: {
      "label": "Power Relay",
      "prop": "power_relay"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Power Relay"
    },
    model: {
      value: (_vm.siteData.power_relay),
      callback: function($$v) {
        _vm.$set(_vm.siteData, "power_relay", $$v)
      },
      expression: "siteData.power_relay"
    }
  }, _vm._l((_vm.devices), function(device) {
    return _c('el-option', {
      key: device.id,
      attrs: {
        "label": device.name,
        "value": device.id
      }
    })
  }))], 1), _vm._v(" "), (_vm.siteData.power_relay > 0) ? _c('div', [_c('el-form-item', {
    staticStyle: {
      "align": "left"
    },
    attrs: {
      "label": "Logical"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Logical no"
    },
    model: {
      value: (_vm.siteData.logical_no),
      callback: function($$v) {
        _vm.$set(_vm.siteData, "logical_no", $$v)
      },
      expression: "siteData.logical_no"
    }
  }, _vm._l((_vm.logicals), function(logical) {
    return _c('el-option', {
      key: logical.logical_no,
      attrs: {
        "label": logical.logical_no,
        "value": logical.logical_no
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Delay",
      "prop": "delay"
    }
  }, [_c('el-input-number', {
    model: {
      value: (_vm.siteData.delay),
      callback: function($$v) {
        _vm.$set(_vm.siteData, "delay", $$v)
      },
      expression: "siteData.delay"
    }
  }), _vm._v(" Seconds\n      ")], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "separator"
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Contact Name",
      "prop": "contact.name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.siteData.contact.name),
      callback: function($$v) {
        _vm.$set(_vm.siteData.contact, "name", $$v)
      },
      expression: "siteData.contact.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Contact Phone",
      "prop": "contact.phone"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.siteData.contact.phone),
      callback: function($$v) {
        _vm.$set(_vm.siteData.contact, "phone", $$v)
      },
      expression: "siteData.contact.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Contact Email",
      "prop": "contact.email"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.siteData.contact.email),
      callback: function($$v) {
        _vm.$set(_vm.siteData.contact, "email", $$v)
      },
      expression: "siteData.contact.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "save"
    },
    on: {
      "click": function($event) {
        _vm.submit('siteData')
      }
    }
  }, [_vm._v("Create")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "cancel"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04a4ba12","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Sites/NewSite.vue
// module id = 993
// module chunks = 10